(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4570,1223],{

/***/ 14953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/media-coverage",
      function () {
        return __webpack_require__(9658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Coverages; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22028);
/* harmony import */ var components_Sidescreen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18291);
/* harmony import */ var lang_en_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64798);
/* harmony import */ var styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(91908);
/* harmony import */ var styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44217);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25617);
/* harmony import */ var components_EmptyBlock__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80326);
/* harmony import */ var store_ux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30807);
/* harmony import */ var store_company_coverage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57202);
/* harmony import */ var components_Card__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83958);
/* harmony import */ var store_company__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3383);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5056);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2962);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23775);




















var __N_SSP = true;
function Coverages(param) {
    var company = param.company, isAuthorized = param.isAuthorized, isAuthenticated = param.isAuthenticated;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(store_company__WEBPACK_IMPORTED_MODULE_11__/* .companySelector */ .yX), _data = ref.data, name = _data.name, companySlug = _data.slug;
    var coverages = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(param) {
        var company = param.company;
        return company.coverages.data;
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var handleAddCoverage = function() {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleShowSidescreen */ .Co)("add-mediaCoverage"));
    };
    var newCoverageButton = isAuthorized && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClick: handleAddCoverage,
        classes: [
            (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().button)
        ],
        title: lang_en_json__WEBPACK_IMPORTED_MODULE_4__/* .profile.media_coverage.button */ .N5.iT.LI
    });
    var handleRemovePopup = function(id) {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleShowPopup */ .YF)());
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .setPopupConfig */ .iH)({
            onConfirm: function() {
                return handleRemoveConfirm(id);
            },
            onCancel: handleRemoveCancel,
            title: "Delete Media coverage?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var handleRemoveConfirm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .setPopupLoading */ .BI)(true));
                        return [
                            4,
                            dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_9__/* .removeCoverage */ .zM)(id))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .setPopupLoading */ .BI)(false));
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleHidePopup */ .Zi)());
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveConfirm(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveCancel = function() {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleHidePopup */ .Zi)());
    };
    var handlePin = function(id) {
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleShowPopup */ .YF)());
        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .setPopupConfig */ .iH)({
            onConfirm: function() {
                return handlePinConfirm(id);
            },
            onCancel: handleRemoveCancel,
            title: "Change pin status of the media coverage?",
            confirmTitle: "Confirm",
            cancelTitle: "Cancel"
        }));
    };
    var handlePinConfirm = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function(id) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .setPopupLoading */ .BI)(true));
                        return [
                            4,
                            dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_9__/* .pinCoverage */ .$2)(id))
                        ];
                    case 1:
                        _state.sent();
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .setPopupLoading */ .BI)(false));
                        dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleHidePopup */ .Zi)());
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePinConfirm(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var published = (coverages === null || coverages === void 0 ? void 0 : coverages.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().cardBlocks),
            children: coverages.map(function(item, key) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    title: item.title,
                    body: item.description,
                    link: item.url,
                    onRemove: isAuthorized && handleRemovePopup,
                    cta: "Read more",
                    id: item.id,
                    limit: 200,
                    status: item.status,
                    onApprove: companySlug === company && isAuthorized && handlePin
                }, "SingleCard-item-".concat(key));
            })
        })
    });
    var handleMarkCoveragesAsSeen = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_17__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,store_company_coverage__WEBPACK_IMPORTED_MODULE_9__/* .seeCoverages */ .Fe)())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMarkCoveragesAsSeen() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isAuthenticated && company === companySlug && (coverages === null || coverages === void 0 ? void 0 : coverages.some(function(param) {
            var status = param.status;
            return status === "new";
        }))) {
            handleMarkCoveragesAsSeen();
        }
    }, []);
    var isEmpty = (coverages === null || coverages === void 0 ? void 0 : coverages.length) < 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_13__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z), {
                titleTemplate: "".concat(name, " Media Coverage | %s")
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isAuthenticated: isAuthenticated,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().wrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: [
                                    "mb-l",
                                    (styles_modules_mediaCoverage_Index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().titleWrapper)
                                ].join(" "),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        variant: "h1",
                                        children: isAuthorized ? lang_en_json__WEBPACK_IMPORTED_MODULE_4__/* .profile.media_coverage.title */ .N5.iT.TN : "".concat(name, "'s Media Coverage")
                                    }),
                                    newCoverageButton
                                ]
                            }),
                            published,
                            isEmpty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_EmptyBlock__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                title: lang_en_json__WEBPACK_IMPORTED_MODULE_4__/* .profile.media_coverage.placeholder_empty */ .N5.iT.Xu
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Sidescreen__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        closeFn: store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleHideSidescreen */ .Qb,
                        onUpdate: function() {
                            dispatch((0,store_ux__WEBPACK_IMPORTED_MODULE_8__/* .handleHideSidescreen */ .Qb)());
                        }
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 91908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Index_wrapper__NuUSz","titleWrapper":"Index_titleWrapper__UymEn","button":"Index_button__RsieF","cardBlocks":"Index_cardBlocks__KwCMm"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2283,9747,9845,8291,1801,9735,9774,2888,179], function() { return __webpack_exec__(14953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);